function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 188.304,
  width: 512,
  height: 134.478
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "152.395,203.412 136.176,187.194 83.478,239.892 30.78,187.194 14.562,203.412 67.307,256.063 14.562,308.808   30.78,324.807 83.478,272.204 136.176,324.807 152.395,308.808 99.65,256.063 "
});

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

function Svg006Mozambique(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.019,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 511.978
  }), /*#__PURE__*/React.createElement("rect", {
    y: 356.173,
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 155.815
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.003,
    style: {
      fill: "#496E2D"
    },
    width: 512,
    height: 156.761
  }), _ref2, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "256,256.007 0,511.994 0,0.003 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "83.477,187.194 100.555,239.755 155.826,239.755 111.113,272.244 128.19,324.807   83.477,292.321 38.763,324.807 55.844,272.244 11.13,239.755 66.399,239.755 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.503,
    y: 255.999,
    style: {
      fill: "#F0F0F0"
    },
    width: 99.962,
    height: 45.869
  }), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg006Mozambique);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3QgeT0iMC4wMTkiIHN0eWxlPSJmaWxsOiNGMEYwRjA7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMS45NzgiLz4KPHJlY3QgeT0iMzU2LjE3MyIgc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iMTU1LjgxNSIvPgo8cmVjdCB5PSIwLjAwMyIgc3R5bGU9ImZpbGw6IzQ5NkUyRDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iMTU2Ljc2MSIvPgo8cmVjdCB5PSIxODguMzA0IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjEzNC40NzgiLz4KPHBvbHlnb24gc3R5bGU9ImZpbGw6I0EyMDAxRDsiIHBvaW50cz0iMjU2LDI1Ni4wMDcgMCw1MTEuOTk0IDAsMC4wMDMgIi8+Cjxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBwb2ludHM9IjgzLjQ3NywxODcuMTk0IDEwMC41NTUsMjM5Ljc1NSAxNTUuODI2LDIzOS43NTUgMTExLjExMywyNzIuMjQ0IDEyOC4xOSwzMjQuODA3ICAgODMuNDc3LDI5Mi4zMjEgMzguNzYzLDMyNC44MDcgNTUuODQ0LDI3Mi4yNDQgMTEuMTMsMjM5Ljc1NSA2Ni4zOTksMjM5Ljc1NSAiLz4KPHJlY3QgeD0iMzMuNTAzIiB5PSIyNTUuOTk5IiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgd2lkdGg9Ijk5Ljk2MiIgaGVpZ2h0PSI0NS44NjkiLz4KPHBvbHlnb24gcG9pbnRzPSIxNTIuMzk1LDIwMy40MTIgMTM2LjE3NiwxODcuMTk0IDgzLjQ3OCwyMzkuODkyIDMwLjc4LDE4Ny4xOTQgMTQuNTYyLDIwMy40MTIgNjcuMzA3LDI1Ni4wNjMgMTQuNTYyLDMwOC44MDggICAzMC43OCwzMjQuODA3IDgzLjQ3OCwyNzIuMjA0IDEzNi4xNzYsMzI0LjgwNyAxNTIuMzk1LDMwOC44MDggOTkuNjUsMjU2LjA2MyAiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };